import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgText = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 10,
	viewBox: "0 0 19 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M10.498 9.05389C10.5707 8.62185 10.6413 8.18981 10.714 7.75997C10.7934 7.29046 10.8705 6.81874 10.9499 6.34922C11.1064 5.40799 11.2629 4.46895 11.4194 3.52772C11.8955 3.52772 12.3739 3.52772 12.85 3.52772C12.6935 4.46895 12.537 5.40799 12.3805 6.34922L12.1446 7.75997C12.0608 8.26916 11.9749 8.77836 11.8911 9.28755C11.8338 9.63142 11.534 9.8761 11.1946 9.8761C11.1571 9.8761 11.1174 9.87389 11.0777 9.86728C10.6942 9.80336 10.4341 9.43965 10.498 9.0561V9.05389ZM11.6553 2.11697L11.9088 0.58939C11.9727 0.205843 12.3364 -0.0542645 12.7199 0.00966015C13.1035 0.0735848 13.3636 0.437294 13.2997 0.820842L13.0858 2.11697H11.6553ZM14.0249 9.05389L14.2409 7.75997H15.6715L15.418 9.28755C15.3607 9.63142 15.0609 9.8761 14.7214 9.8761C14.684 9.8761 14.6443 9.87389 14.6046 9.86728C14.2211 9.80336 13.961 9.43965 14.0249 9.0561V9.05389ZM14.4768 6.34922C14.6333 5.40799 14.7898 4.46895 14.9463 3.52772L15.1821 2.11697C15.2659 1.60778 15.3519 1.09858 15.4356 0.58939C15.4996 0.205843 15.8633 -0.0542645 16.2468 0.00966015C16.5929 0.0691762 16.8376 0.366756 16.8376 0.706218C16.8376 0.743691 16.8354 0.783369 16.8287 0.823046C16.756 1.25509 16.6855 1.68713 16.6127 2.11697C16.5334 2.58648 16.4562 3.0582 16.3769 3.52772C16.2204 4.46895 16.0639 5.40799 15.9074 6.34922H14.4768Z",
			fill: "url(#paint0_linear_7940_104539)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1811 2.11694H10.1355C9.74532 2.11694 9.43011 2.43216 9.43011 2.82232C9.43011 3.21248 9.74532 3.52769 10.1355 3.52769H14.9453L15.1811 2.11694ZM16.3758 3.52769H17.8946C18.2848 3.52769 18.6 3.21248 18.6 2.82232C18.6 2.43216 18.2848 2.11694 17.8946 2.11694H16.6117L16.3758 3.52769ZM12.1436 7.75995H17.1892C17.5794 7.75995 17.8946 7.44473 17.8946 7.05457C17.8946 6.66441 17.5794 6.3492 17.1892 6.3492H12.3795L12.1436 7.75995ZM10.9489 6.3492H9.43011C9.03995 6.3492 8.72473 6.66441 8.72473 7.05457C8.72473 7.44473 9.03995 7.75995 9.43011 7.75995H10.713L10.9489 6.3492Z",
			fill: "url(#paint1_linear_7940_104539)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.54177 0.458494C4.43817 0.182957 4.17366 0 3.88048 0C3.58731 0 3.3228 0.182957 3.2192 0.458494L0.0450065 8.923C-0.09166 9.28671 0.093501 9.6945 0.45721 9.83117C0.820919 9.96784 1.22871 9.78267 1.36538 9.41897L2.12145 7.40644H5.63951L6.39338 9.41676C6.53005 9.78047 6.93785 9.96563 7.30156 9.82897C7.66526 9.6923 7.85042 9.28671 7.71376 8.92079L4.54177 0.458494ZM5.11048 5.99569H2.65049L3.88048 2.71349L5.11048 5.99569Z",
			fill: "url(#paint2_linear_7940_104539)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_7940_104539",
				x1: 10.4883,
				y1: 4.93805,
				x2: 16.8376,
				y2: 4.93805,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01D5AB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_7940_104539",
				x1: 8.72473,
				y1: 4.93844,
				x2: 18.6,
				y2: 4.93844,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01D5AB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_7940_104539",
				x1: 0,
				y1: 4.93809,
				x2: 7.75877,
				y2: 4.93809,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#01D5AB"
				})]
			})
		] })
	]
});
export { SvgText as ReactComponent };
